var $52b96f86422025af$exports = {};
$52b96f86422025af$exports = {
  "dismiss": "\uBB34\uC2DC"
};
export { $52b96f86422025af$exports as default };